import * as React from 'react';
import AboutHero from './AboutHero';
import AboutStory from './AboutStory';
import AboutValues from './AboutValues';
import AboutTeam from './AboutTeam';

const AboutPage: React.FC = () => {
  return (
    <React.Fragment>
      <AboutHero />
      <AboutStory />
      <AboutValues />
      <AboutTeam />
    </React.Fragment>
  );
};

export default AboutPage; 